import request from "~/utils/http";

const masterApi = {
	gets : async (params) => {
		const url = 'v1/master-data';
		return await request.get(url);
	}
};

export default masterApi;